<div class="preview-row preview-row--total" *ngIf="loading">
  <span class="preview-label">Hoy pagas</span>
  <span class="preview-value preview-value--muted">Calculando…</span>
</div>

<ng-container *ngIf="!loading && loaded">
  <div class="preview-row preview-row--total">
    <span class="preview-label">Hoy pagas{{ taxToday > 0 ? ' (IVA incl.)' : '' }}</span>
    <span class="preview-value preview-value--total">{{ amountDueToday | number:'1.2-2' }} €</span>
  </div>
  <div class="preview-row">
    <span class="preview-label">
      {{ isDowngrade ? 'Cambio efectivo el' : 'Próxima renovación' }} {{ (isDowngrade ? effectiveDate : nextRenewalDate) | date:'dd/MM/yyyy' }}
    </span>
    <span class="preview-value">{{ renewalAmount | number:'1.2-2' }} €/{{ periodLabel }}</span>
  </div>
</ng-container>
